import { render, staticRenderFns } from "./VendorInventoryItemDialog.vue?vue&type=template&id=80fad13e"
import script from "./VendorInventoryItemDialog.vue?vue&type=script&lang=js"
export * from "./VendorInventoryItemDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports